<template >
  <v-app>
    <div v-if="addEditItemDialog == false">
      <div style="margin-bottom:10px;margin-top:10px;">
        <!-- <h3>Menu</h3> -->
        <v-btn
          color="primary"
          style="float:right;padding-left:20px;margin-top:-2px;"
          @click="addMenu('new',0)"
        >{{$t('Add')}}</v-btn>
        <v-layout>
          <input
            v-model="searchItemVal"
            type="text"
            class="form-control"
            name="searchItemVal"
            autocomplete="nope"
            :placeholder="$t('SearchItem')"
            @input="searchItemVal = $event.target.value"
          />
          <v-icon @click="searchItem(searchItemVal)">search</v-icon>
        </v-layout>
      </div>

      <div style="text-align: center;">
        <h3
          v-if="errorList != ''"
          style="font-size:14px;"
          class="txtClrRed"
        >{{$t('ErrorList')}}: {{errorList}}</h3>
        <h3
          v-if="errorItemInfo != ''"
          style="font-size:14px;"
          class="txtClrRed"
        >{{$t('ErrorItemInfo')}}: {{errorItemInfo}}</h3>
      </div>

      <!-- table Menu -->
      <v-data-iterator :items="itemList" content-tag="v-layout" hide-actions wrap>
        <template slot="item" slot-scope="props">
          <v-layout class="menuItemListLayout">
            <button class="btn mainListItemBtn" style="width:100%;height:auto;padding:0px;">
              <v-card style="width:100%;height:auto;">
                <v-card-title style="padding:0px;">
                  <div
                    v-if="props.item.oc == false && props.item.lc == true"
                    style="max-width:40%;padding-left:5px;"
                    @click="addMenu('edit',props.item.kt)"
                  >
                    <img
                      class="smallImgWidth"
                      style="width: 100%;height: auto; margin:auto;max-width:80px;"
                      :src="props.item.kw"
                    />
                  </div>
                  <div
                    v-if="props.item.oc== false && props.item.lc == false"
                    style="max-width:40%;padding-left:5px;"
                    @click="addMenu('edit',props.item.kt)"
                  >
                    <img
                      class="smallImgWidth"
                      style="width: 100%;height: auto; margin:auto;max-width:80px;"
                      :src="props.item.kw"
                    />
                    <img
                      class="smallImgWidth"
                      style="width: 40%;height: 80px;width: 80px; margin:auto;position: absolute; top: 14%; left: 5px;"
                      src="./assets/noActive.png"
                    />
                  </div>
                  <div
                    v-if="props.item.oc && props.item.lc"
                    style="max-width:40%;padding-left:5px;"
                    @click="addMenu('edit',props.item.kt)"
                  >
                    <img
                      class="smallImgWidth"
                      style="width: 100%;height: auto; margin:auto;max-width:80px;"
                      :src="props.item.kw"
                    />
                    <img
                      class="smallImgWidth"
                      style="width: 40%;height: 80px;width: 80px; margin:auto;position: absolute; top: 14%; left: 5px;"
                      src="./assets/soldOut.png"
                    />
                  </div>
                  <div
                    v-if="props.item.oc && props.item.lc == false"
                    style="max-width:40%;padding-left:5px;"
                    @click="addMenu('edit',props.item.kt)"
                  >
                    <img
                      class="smallImgWidth"
                      style="width: 100%;height: auto; margin:auto;max-width:80px;"
                      :src="props.item.kw"
                    />
                    <img
                      class="smallImgWidth"
                      style="width: 40%;height: 80px;width: 80px; margin:auto;position: absolute; top: 14%; left: 5px;"
                      src="./assets/noActive.png"
                    />
                  </div>
                  <div style="width:63%;margin:5px;">
                    <div
                      style="padding:5px;padding-bottom:0px;"
                      class="subheading font-weight-bold"
                      @click="addMenu('edit',props.item.kt)"
                    >
                      <p
                        style="margin:0px;text-align:left;font-size:14px;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;"
                      >{{ props.item.ku }}</p>
                    </div>
                    <div
                      class="font-weight-bold"
                      style="padding-top:0px !important;padding-bottom:0px !important;min-height:23px;"
                      @click="addMenu('edit',props.item.kt)"
                    >
                      <v-card-title v-if="props.item.sd" style="padding:0px;">
                        <p class="sellingFast" style="width:auto;">{{$t('SellingFast')}}</p>
                      </v-card-title>
                    </div>
                    <div
                      class="font-weight-bold itemPriceColor"
                      style="padding-top:0px !important;padding-bottom:0px !important;"
                      @click="addMenu('edit',props.item.kt)"
                    >
                      <p style="margin:0px;text-align:left;font-size:18px;">RM {{ props.item.lp }}</p>
                    </div>
                    <button
                      class="menuItemBtmBtn"
                      style="background-color:red;color:white;border-radius:5px;float:right;"
                      @click="setSoldOut(props.item.kt)"
                    >{{$t('SoldOut')}}</button>
                    <button
                      class="menuItemBtmBtn"
                      style="background-color:orange;color:white;border-radius:5px;float:right;"
                      @click="setSellingFast(props.item.kt)"
                    >{{$t('SellingFast')}}</button>
                    <!-- <button
                      class="menuItemBtmBtn"
                      style="background-color:#1976d2;color:white;border-radius:5px;"
                      @click="addMenu('edit',props.item.kt)"
                    >{{$t('Edit')}}</button>-->
                  </div>
                </v-card-title>
              </v-card>
            </button>
          </v-layout>
        </template>
        <template v-slot:no-data>
          <!-- <h3 style="margin:15px;text-align:center;">{{$t('NoItemFound')}}</h3> -->
          <h3 style="margin:15px;text-align:center;">{{NoItemMsg}}</h3>
        </template>
      </v-data-iterator>
    </div>

    <div v-if="addEditItemDialog == true">
      <h4 style="margin:0px;font-size:20px;margin-top:10px;">
        <span v-if="newOrEdit == 'new'">{{$t('NewMenu')}}</span>
        <span v-if="newOrEdit == 'edit'">{{$t('EditMenu')}}</span>
      </h4>

      <v-layout wrap>
        <v-flex xs12>
          <div style="text-align: center;">
            <h3
              v-if="emptyPropName != ''"
              style="font-size:14px;"
              class="txtClrRed"
            >{{''+$t(emptyPropName)+''}}</h3>
            <h3
              v-if="emptyPriceName != ''"
              style="font-size:14px;"
              class="txtClrRed"
            >{{''+$t(emptyPriceName)+''}}</h3>
            <h3
              v-if="errorMenuWithTran != ''"
              style="font-size:14px;"
              class="txtClrRed"
            >{{$t('ErrorMenu')}}: {{''+$t(errorMenuWithTran)+''}}</h3>
            <h3
              v-if="errorMenu != ''"
              style="font-size:14px;"
              class="txtClrRed"
            >{{$t('ErrorMenu')}}: {{errorMenu}}</h3>
          </div>

          <v-btn
            color="primary"
            style="float:right;width:43%;margin-top:0px;"
            @click="saveMenu()"
          >{{$t('Save')}}</v-btn>
          <v-btn
            color="error"
            style="width:43%;margin-top:0px;"
            @click="cancelAddEditItemDialog()"
          >{{$t('Cancel')}}</v-btn>
        </v-flex>
      </v-layout>

      <v-card style="padding:5px;background-color:#f1f1f1;">
        <v-layout wrap>
          <croppa
            v-model="myCroppa"
            style="display:none;"
            :width="300"
            :height="300"
            :prevent-white-space="true"
            :show-remove-button="true"
            :disable-drag-and-drop="true"
            :disable-click-to-choose="true"
            :disable-drag-to-move="true"
            :disable-scroll-to-zoom="true"
            :show-loading="true"
            @file-choose="handleCroppaFileChoose"
            @new-image-drawn="handleNewImage"
          ></croppa>

          <!-- Add Img -->
          <v-flex xs12 style="margin-top:10px;">
            <v-layout>
              <v-flex xs4>
                <!-- <h6 class="backEndMenuTxt">Image:</h6> -->
                <!-- @click="$refs.fileTNInput.click()" -->

                <button
                  v-if="imgUrl == ''"
                  class="imgBorder"
                  style="margin:5px;padding:20px;background-color:white;font-size:50px;border-radius:5px;"
                >+</button>

                <div>
                  <img
                    v-if="imgUrl != ''"
                    class="imgBorder"
                    style="padding:5px; margin:5px;border:0.5px solid grey;border-radius:5px;"
                    :src="imgUrl"
                  />
                </div>
              </v-flex>

              <v-flex xs8 style="padding:10px;">
                <v-layout style="max-width:160px;">
                  <v-flex xs7>
                    <button
                      style="margin:0px 0px 0px 5px;width:80%;height:40px;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
                      @click="chooseMenuImg()"
                    >{{$t('Choose')}}</button>
                  </v-flex>

                  <v-flex v-if="imgUrl != ''" xs5>
                    <button
                      style="margin:0px 0px 0px 5px;width: 80%;height:40px;background-color:red;color:white;font-size:14px;border-radius:5px;"
                      @click="removeMenuImg()"
                    >{{$t('Clear')}}</button>
                  </v-flex>
                </v-layout>

                <div style="text-align: center;">
                  <h3
                    v-if="errImgWithTran != ''"
                    style="font-size:14px;"
                    class="txtClrRed"
                  >{{$t('ErrorImage')}}: {{''+$t(errImgWithTran)+''}}</h3>
                  <h3
                    v-if="errImg != ''"
                    style="font-size:14px;"
                    class="txtClrRed"
                  >{{$t('ErrorImage')}}: {{errImg}}</h3>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <h6 class="backEndMenuTxt">{{$t('Name')}}:</h6>
            <input
              v-model="mdfItemName"
              class="form-control"
              required
              autocomplete="nope"
              type="text"
              name="mdfItemName"
              @input="mdfItemName = $event.target.value"
            />

            <br />
            <h6 class="backEndMenuTxt">{{$t('Description')}}:</h6>
            <editor
              ref="editorText"
              :initial-value="mdfItemDesp"
              :options="editorOptions"
              height="350px"
              initial-edit-type="wysiwyg"
              preview-style="vertical"
            />
            <!-- <div class="editorText" v-html="mdfItemDesp"></div> -->
            <br />

            <!-- <input
              v-model="mdfItemDesp"
              class="form-control"
              required
              autocomplete="nope"
              type="text"
              name="mdfItemDesp"
              @input="mdfItemDesp = $event.target.value"
            />-->

            <h6 class="backEndMenuTxt">{{$t('Category')}}:</h6>
            <input
              v-model="mdfItemCatName"
              class="form-control"
              required
              autocomplete="nope"
              type="text"
              name="mdfItemCatName"
              @input="mdfItemCatName = $event.target.value"
            />

            <v-layout>
              <v-flex xs4 class="cboxActive">
                <v-checkbox
                  v-model="cActive"
                  style="margin-top:6px;color:black;"
                  color="primary"
                  :label="$t('Active')"
                ></v-checkbox>
              </v-flex>
              <v-flex xs4>
                <v-checkbox
                  v-model="cSellingFast"
                  style="margin-top:6px;color:black;"
                  color="primary"
                  :label="$t('SellingFast')"
                ></v-checkbox>
              </v-flex>
              <v-flex xs4>
                <v-checkbox
                  v-model="cSoldOut"
                  style="margin-top:6px;color:black;"
                  color="primary"
                  :label="$t('SoldOut')"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card style="padding:5px;background-color:#f1f1f1;margin-top:15px;">
        <v-layout wrap>
          <!-- Item Price -->
          <v-flex xs12>
            <h5 class="backEndMenuTxt" style="font-size:20px;">
              {{$t('Price')}}:
              <button
                style="margin-top:-5px;width:80px;height:29px;padding:5px;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;float:right;"
                @click="addPrice()"
              >{{$t('AddPrice')}}</button>
            </h5>
            <!-- <div style="text-align: center;">
              <h3
                v-if="emptyPriceName != ''"
                style="font-size:14px;"
                class="txtClrRed"
              >{{''+$t(emptyPriceName)+''}}</h3>
            </div>-->

            <v-card style="overflow-y: scroll;">
              <table class="tableList">
                <thead>
                  <tr>
                    <!-- <th class="text-left">Num</th> -->
                    <th class="text-left">{{$t('Name')}}</th>
                    <th style="max-width:75px;" class="text-left">{{$t('Price')}}</th>
                    <th style="max-width:30px;" class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(price,i) in itemPriceList" :key="price.id">
                    <!-- <td class="text-center">{{i +1}}</td> -->
                    <td>
                      <input
                        v-model="price.kz"
                        autocomplete="nope"
                        type="text"
                        required
                        class="form-control"
                        name="mdfItemPrcName"
                        @input="mdfItemPrcName = $event.target.value"
                        @change="setItemPriceNameInfo(mdfItemPrcName, i)"
                      />
                    </td>
                    <td>
                      <input
                        v-model="price.lp"
                        class="form-control priceInputWidth"
                        type="number"
                        required
                        step="any"
                        name="mdfItemPrc"
                        autocomplete="nope"
                        @input="mdfItemPrc = $event.target.value"
                        @change="setItemPriceInfo(mdfItemPrc, i)"
                      />
                    </td>
                    <td style="max-width:30px;">
                      <v-icon style="float:right;color:black;" @click="deleteItmPrc(i)">delete</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card style="padding:5px;background-color:#f1f1f1;margin-top:15px;margin-bottom:15px;">
        <v-layout wrap>
          <!-- Item Property -->
          <v-flex xs12>
            <h4 class="backEndMenuTxt" style="font-size:20px;">
              {{$t('Property')}}:
              <button
                style="margin-top:-5px;float:right;width:120px;height:29px;padding:5px;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
                @click="addProperty()"
              >{{$t('AddProperty')}}</button>
            </h4>
            <!-- <div style="text-align: center;">
              <h3
                v-if="emptyPropName != ''"
                style="font-size:14px;"
                class="txtClrRed"
              >{{''+$t(emptyPropName)+''}}</h3>
            </div>-->

            <v-card v-if="itemPropList.length > 0" style="overflow-y: scroll;">
              <table class="tableList">
                <thead>
                  <tr>
                    <!-- <th class="text-left">Num</th> -->
                    <th style="min-width:120px;" class="text-left">{{$t('Name')}}</th>
                    <th style="width:auto;">{{$t('Price')}}</th>
                    <th style="width:auto;">{{$t('type')}}</th>
                    <th style="width:auto;" class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prop,i) in itemPropList" :key="prop.id">
                    <!-- <td class="text-center">{{i +1}}</td> -->
                    <td>
                      <input
                        v-model="prop.ez"
                        class="form-control"
                        required
                        autocomplete="nope"
                        type="text"
                        name="mdfItemPropName"
                        @input="mdfItemPropName = $event.target.value"
                        @change="setItemPropNameInfo(mdfItemPropName, i)"
                      />
                    </td>
                    <td>
                      <input
                        v-model="prop.lp"
                        class="form-control priceInputWidth"
                        required
                        step="any"
                        autocomplete="nope"
                        type="number"
                        name="mdfItemProp"
                        @input="mdfItemProp = $event.target.value"
                        @change="setItemPropInfo(mdfItemProp, i)"
                      />
                    </td>
                    <td class="vSlt" style="width:80px !important;">
                      <v-select
                        v-model="prop.gmName"
                        style="width:100%;font-size:12px;"
                        :items="btnTypeList"
                        @input="onSelectBtnType($event, i)"
                      ></v-select>
                    </td>
                    <td style="max-width:30px;">
                      <v-icon style="float:right;color:black;" @click="deleteItmProp(i)">delete</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </div>

    <v-layout class="text-xs-center">
      <v-dialog v-model="deleteItmPrcDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToRemoveThisItemPriceTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltPrc()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="deleteItmPrcDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout class="text-xs-center">
      <v-dialog v-model="deleteItmPropDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToRemoveThisItemPropertyTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltProp()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="deleteItmPropDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout class="text-xs-center">
      <v-dialog v-model="clearImgDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToRemoveThisItemImageTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltImg()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="clearImgDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout class="text-xs-center">
      <v-dialog v-model="foundZeroPriceItemDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToSetZeroPriceForItemTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="saveAddEditItem()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="foundZeroPriceItemDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import { getOrientation } from 'get-orientation/browser'
//import * as EXIF from 'exif-js'
import JS from './JsonService'
import { translateErrorMsg } from './translateErrorMsg'
import VersionDialog from '../src/VersionNotMatchDialog'

import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'
import colorSyntax from '@toast-ui/editor-plugin-color-syntax'
import { Editor } from '@toast-ui/vue-editor'

export default {
  components: {
    editor: Editor,
    VersionDialog
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      editorOptions: {
        plugins: [colorSyntax],
        useCommandShortcut: true,
        useDefaultHTMLSanitizer: true,
        usageStatistics: false,
        hideModeSwitch: true,
        toolbarItems: [
          'heading',
          'bold',
          'italic',
          'strike',
          'divider',
          'hr',
          'quote',
          'divider',
          'ul',
          'ol',
          // 'task',
          'indent',
          'outdent',
          'divider',
          'table',
          'image',
          'link'
        ]
      },
      initEditorText: '',
      editorText: '',

      itemId: 0,
      searchItemVal: '',
      itemList: [],
      errorList: '',
      addEditItemDialog: false,
      itemPriceList: [],
      itemPropList: [],
      itemInfo: [],
      errorItemInfo: '',

      mdfItemName: '',
      mdfItemDesp: '',
      mdfItemCatName: '',
      cActive: true,
      cSellingFast: false,
      cSoldOut: false,
      mdfItemPrcName: '',
      mdfItemPrc: '',

      addNewPrice: false,
      addNewProp: false,
      emptyPriceName: '',
      emptyPropName: '',
      mdfItemPropName: '',
      mdfItemProp: '',
      deleteItmPrcDialog: false,
      deleteItmPropDialog: false,
      dltPrcIndex: 0,
      dltPropIndex: 0,
      errorMenu: '',
      errorMenuWithTran: '',
      ListOfItemPriceToServer: [],
      ListOfPropToServer: [],
      stallInfo: [],
      newOrEdit: '',
      found: false,
      foundID: 0,
      samePriceName: false,
      samePropName: false,
      sltInputImgFile: [],
      urlTN: '',
      itemInfoUrlTN: '',
      imgTNInfo: [],
      tnImgItem: [],
      fsImgItem: [],
      oriImgWidth: 0,
      oriImgHeight: 0,
      errImg: '',
      errImgWithTran: '',
      clearImgDialog: false,
      dltAllImg: false,
      foundZeroPriceItemDialog: false,
      loadingDialog: false,
      diffX: 0,
      diffY: 0,
      diffOri: 0,
      exifOrientation: 0,
      versionError: false,
      myCroppa: {},
      imgUrl: '',
      croppaImgFile: [],
      itemPrevImg: '',
      NoItemMsg: 'No Item Found',
      btnTypeList: ['Once', 'Multiple']
    }
  },
  created: function() {
    if (sessionStorage.getItem('NoItemMsg') != '') {
      this.NoItemMsg = sessionStorage.getItem('NoItemMsg')
    }
    this.getItemList()
  },
  destroyed() {
    console.log('destroy')
  },
  mounted() {
    //console.log('this is quill instance object', this.editor)
  },
  methods: {
    async onFileChanged(fileInput) {
      const orientation = await getOrientation(fileInput)
      console.log(orientation)
      //alert(orientation)
      this.changeOrientation(fileInput, 600, 600, orientation)
    },
    handleCroppaFileChoose(val) {
      this.loadingDialog = true
      console.log(val)
      this.croppaImgFile = val
    },
    handleNewImage() {
      let url = this.myCroppa.generateDataUrl('image/jpeg', 0.8)
      console.log(url)
      //console.log(this.myCroppa.$parent.chosenFile)
      this.croppaImgFile = this.base64toFile(
        this.croppaImgFile.name.substr(
          0,
          this.croppaImgFile.name.lastIndexOf('.')
        ) + '.jpeg',
        url
      )
      this.imgUrl = url
      this.loadingDialog = false
    },
    chooseMenuImg() {
      this.myCroppa.chooseFile()
    },
    removeMenuImg() {
      this.clearImgDialog = true
    },
    getItemList() {
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      console.log(userInfo)
      console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Order/GetItemList'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        gm: 4, //Fixed
        la: 0, //Fixed
        le: 0, //Fixed
        mr: '',
        dv: this.searchItemVal
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfItem) {
              this.loadingDialog = false
              this.errorList = ''
              this.itemList = response.data.ListOfItem
              for (let i = 0; i < this.itemList.length; i++) {
                if (this.itemList[i].kw == '' || this.itemList[i].kw == null) {
                  var defaultImg = require('./assets/ImgNotFound.png')
                  this.itemList[i].kw = defaultImg
                } else {
                  this.itemList[i].kw = JS.checkImg(this.itemList[i].kw)
                }
                if (this.itemList[i].kx == '' || this.itemList[i].kx == null) {
                  var defaultImg2 = require('./assets/ImgNotFound.png')
                  this.itemList[i].kx = defaultImg2
                } else {
                  this.itemList[i].kx = JS.checkImg(this.itemList[i].kx)
                }
              }
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.loadingDialog = false
          this.errorList = error
        })
    },
    searchItem(value) {
      console.log(value)
      this.searchItemVal = value.trim()
      this.getItemList()
    },
    setSellingFast(itmId) {
      this.loadingDialog = true
      this.versionError = false
      //console.log(itmId)
      //console.log(this.itemList)
      for (let i = 0; i < this.itemList.length; i++) {
        if (itmId == this.itemList[i].kt) {
          if (this.itemList[i].sd == true) {
            this.cSellingFast = false
          } else {
            this.cSellingFast = true
          }
          break
        }
      }

      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))

      var version = sessionStorage.getItem('version')
      const url = 'Back/SellingFast'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        kt: itmId,
        sd: this.cSellingFast
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.errorList = ''
              for (let i = 0; i < this.itemList.length; i++) {
                if (itmId == this.itemList[i].kt) {
                  this.itemList[i].sd = this.cSellingFast
                  break
                }
              }
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    },
    setSoldOut(itmId) {
      this.loadingDialog = true
      this.versionError = false
      //console.log(itmId)
      //console.log(this.itemList)
      for (let i = 0; i < this.itemList.length; i++) {
        if (itmId == this.itemList[i].kt) {
          if (this.itemList[i].oc == true) {
            this.cSoldOut = false
          } else {
            this.cSoldOut = true
          }
          break
        }
      }

      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))

      var version = sessionStorage.getItem('version')
      const url = 'Back/SoldOut'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        kt: itmId,
        oc: this.cSoldOut
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.errorList = ''
              for (let i = 0; i < this.itemList.length; i++) {
                if (itmId == this.itemList[i].kt) {
                  this.itemList[i].oc = this.cSoldOut
                  break
                }
              }
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    },
    addMenu(mode, itmId) {
      this.versionError = false
      this.loadingDialog = true
      //reset
      this.emptyPriceName = ''
      this.emptyPropName = ''
      this.errorMenu = ''
      this.errorMenuWithTran = ''
      this.errImg = ''
      this.errImgWithTran = ''
      this.tnImgItem = []
      this.fsImgItem = []
      this.croppaImgFile = []

      //Get Item Info
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      //console.log(itmId)

      var version = sessionStorage.getItem('version')
      const url = 'Order/GetItemInfo'
      const parameter = {
        av: version,
        kp: mchCode,
        kt: itmId
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfItem) {
              this.loadingDialog = false
              this.errorItemInfo = ''
              this.itemInfo = response.data
              this.addEditItemDialog = true
              window.scrollTo(0, 0)

              console.log(itmId)
              this.itemId = itmId
              this.errorMenu = ''
              this.newOrEdit = mode
              if (this.newOrEdit == 'edit') {
                for (let i = 0; i < this.itemInfo.ListOfItem.length; i++) {
                  if (this.itemInfo.ListOfItem[i].kt == itmId) {
                    console.log('Item Info', this.itemInfo)
                    this.itemInfoUrlTN = this.itemInfo.ListOfItem[i].kw
                    if (
                      this.itemInfo.ListOfItem[i].kw != null &&
                      this.itemInfo.ListOfItem[i].kw != ''
                    ) {
                      this.urlTN = JS.checkImg(this.itemInfo.ListOfItem[i].kw)
                      this.imgUrl = JS.checkImg(this.itemInfo.ListOfItem[i].kw)
                      this.itemPrevImg = JS.checkImg(
                        this.itemInfo.ListOfItem[i].kw
                      )
                    } else {
                      this.urlTN = ''
                      this.imgUrl = ''
                      this.itemPrevImg = ''
                    }
                    this.mdfItemName = this.itemInfo.ListOfItem[i].ku
                    this.mdfItemDesp = this.itemInfo.ListOfItem[i].kv
                    this.mdfItemCatName = this.itemInfo.ListOfItem[i].mr
                    this.cActive = this.itemInfo.ListOfItem[i].lc
                    this.cSellingFast = this.itemInfo.ListOfItem[i].sd
                    this.cSoldOut = this.itemInfo.ListOfItem[i].oc
                    this.itemPriceList = this.itemInfo.ListOfPrice
                    this.itemPropList = this.itemInfo.ListOfProp
                    for (let i = 0; i < this.itemPropList.length; i++) {
                      if (this.itemPropList[i].gm == 0) {
                        this.itemPropList[i].gmName = 'Once'
                      } else if (this.itemPropList[i].gm == 3) {
                        this.itemPropList[i].gmName = 'Multiple'
                      }
                    }
                    break
                  }
                }
              } else {
                this.mdfItemName = ''
                this.mdfItemDesp = ''
                this.mdfItemCatName = ''
                this.cActive = true
                this.cSellingFast = false
                this.cSoldOut = false
                this.itemPriceList = []
                this.itemPropList = []
                this.urlTN = ''
                this.imgUrl = ''
                //console.log(this.itemPriceList)
                if (this.itemPriceList.length == 0) {
                  this.itemPriceList.push({
                    ky: 0,
                    kt: 0,
                    kz: '',
                    lp: 0,
                    ou: 0
                  })
                  //console.log(this.itemPriceList)
                }
                // if (this.itemPropList.length == 0) {
                //   this.itemPropList.push({ oo: 0, kt: 0, ez: '', lp: 0 })
                //   //console.log(this.itemPropList)
                // }
              }
            } else {
              this.loadingDialog = false
              this.versionError = false
              this.errorItemInfo = response.data
              this.addEditItemDialog = false
              window.scrollTo(0, 0)
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.errorItemInfo = error
          this.addEditItemDialog = false
          window.scrollTo(0, 0)
        })
    },
    setItemPriceNameInfo(val, i) {
      console.log(val)
      console.log(i)
      this.itemPriceList[i].kz = val
      console.log(this.itemPriceList)
    },
    setItemPriceInfo(val2, i) {
      console.log(val2)
      console.log(i)
      if (val2 == null) {
        val2 = 0
      }
      this.itemPriceList[i].lp = val2
      console.log(this.itemPriceList)
    },
    onFileSelected(val) {
      this.loadingDialog = true
      console.log(val)
      this.sltInputImgFile = val.target.files[0]
      console.log(this.sltInputImgFile)

      if (this.sltInputImgFile != '' && this.sltInputImgFile != undefined) {
        //this.urlTN = URL.createObjectURL(this.sltInputImgFile)
        this.loadImgWH()

        //this.imgTNInfo = []
        // const reader = new FileReader()
        // reader.onload = e => {
        //   const newImgItem = {
        //     imgPath: e.target.result,
        //     imgAlt: this.sltInputImgFile.name,
        //     file: this.sltInputImgFile,
        //     id: 0
        //   }
        //   this.imgTNInfo.push(newImgItem)
        //   console.log(this.imgTNInfo)
        //   this.changeOrientation(this.imgTNInfo)
        // }
        // reader.readAsDataURL(this.sltInputImgFile)
      } else {
        this.loadingDialog = false
      }
    },
    loadImgWH() {
      var reader = new FileReader()
      var oriImg = new Image()
      let myFirstPromise = new Promise(resolve => {
        reader.onload = function(readerEvent) {
          oriImg.onload = function() {
            console.log(oriImg.width)
            console.log(oriImg.height)

            if (oriImg.width < 500 || oriImg.height < 500) {
              //console.log('must min 600')
              //resolve('Image width & heigth must be at least 600px!')
              const WHInfo = { width: oriImg.width, height: oriImg.height }
              console.log(readerEvent.target.result)
              resolve(WHInfo)
            } else {
              if (oriImg.width - oriImg.height > 100) {
                const WHInfo = { width: oriImg.width, height: oriImg.height }
                console.log(readerEvent.target.result)
                resolve(WHInfo)
                //console.log('must square')
                //resolve('Image must be square!')
              } else {
                const WHInfo = { width: oriImg.width, height: oriImg.height }
                console.log(readerEvent.target.result)
                resolve(WHInfo)
              }
            }
          }
          oriImg.src = readerEvent.target.result
        }
        reader.readAsDataURL(this.sltInputImgFile)
      })

      myFirstPromise.then(Msg => {
        this.errImgWithTran = ''
        if (Msg.width) {
          this.errImg = ''
          console.log('real width:' + Msg.width + 'real height:' + Msg.height)
          this.oriImgWidth = Msg.width
          this.oriImgHeight = Msg.height
          this.urlTN = URL.createObjectURL(this.sltInputImgFile)
          console.log(this.sltInputImgFile)
          console.log(this.urlTN)
          this.onFileChanged(this.sltInputImgFile)
          //this.changeOrientation(this.sltInputImgFile, 600, 600, this.urlTN)
          //this.updateFsImage()
        } else {
          this.loadingDialog = false
          console.log(Msg)
          // this.sltInputImgFile = ''
          // this.urlTN = ''
          this.errImgWithTran = translateErrorMsg.translateMsg(Msg)
        }
      })

      // var reader = new FileReader()
      // reader.onload = function(readerEvent) {
      //   var face_image = new Image()
      //   face_image.onload = function() {
      //     this.oriImgWidth = face_image.width
      //     this.oriImgHeight = face_image.height
      //     // this.changeOrientation(this.sltInputImgFile, width, height)
      //     sessionStorage.setItem(
      //       'oriImgWH',
      //       JSON.stringify({
      //         width: face_image.width,
      //         height: face_image.height,
      //         src: readerEvent.target.result
      //       })
      //     )
      //   }
      //   face_image.src = readerEvent.target.result
      // }
      // reader.readAsDataURL(this.sltInputImgFile)
      // let _this = this
      // setTimeout(function() {
      //   if (sessionStorage.getItem('oriImgWH')) {
      //     var oriImg = JSON.parse(sessionStorage.getItem('oriImgWH'))
      //     console.log(oriImg)
      //     console.log(oriImg.width)
      //     console.log(oriImg.height)
      //     if (
      //       oriImg.width != 0 &&
      //       oriImg.width != undefined &&
      //       oriImg.height != 0 &&
      //       oriImg.height != undefined
      //     ) {
      //       _this.changeOrientation(
      //         _this.imgTNInfo,
      //         oriImg.width,
      //         oriImg.height,
      //         oriImg.src
      //       )
      //     }
      //   }
      // }, 100)
    },
    changeOrientation(imgTNInfo, w, h, orientation) {
      console.log(this.imgTNInfo)
      var img = new Image()
      console.log('1.1', imgTNInfo)
      img.src = this.urlTN
      console.log('1.2', img.src)

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      var exifOrientation = orientation
      console.log('1.2.3', img)
      var width = w,
        height = h
      console.log('1.2.1', width)
      console.log('1.2.2', height)

      console.log('imageWidth', width)
      console.log('imageHeight:', height)

      // Check orientation in EXIF metadatas
      // var img1 = document.getElementById('img1')
      console.log(img)

      // EXIF.getData(img, function() {
      //   EXIF.getAllTags(this)
      //   exifOrientation = EXIF.getTag(this, 'Orientation')
      // })
      // console.log(exifOrientation)

      // EXIF.getData(img, () => {
      //   const allMetaData = EXIF.getAllTags(img)
      //   console.log('1.3', '11111', img)
      //   console.log('1.4', allMetaData)
      //   exifOrientation = allMetaData.Orientation
      // })

      // set proper canvas dimensions before transform & export
      if ([5, 6, 7, 8].indexOf(exifOrientation) > -1) {
        canvas.width = height
        canvas.height = width
      } else {
        canvas.width = width
        canvas.height = height
      }
      console.log('1.5 exifOrientation:', exifOrientation)
      // transform context before drawing image
      switch (exifOrientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0)
          break
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height)
          break
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height)
          break
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0)
          break
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0)
          break
        case 7:
          ctx.transform(0, -1, -1, 0, height, width)
          break
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width)
          break
        default:
          ctx.transform(1, 0, 0, 1, 0, 0)
      }

      this.diffWidth = 0
      if (this.oriImgWidth > this.oriImgHeight) {
        this.diffX = (this.oriImgWidth - this.oriImgHeight) / 2
        this.diffY = 0
        this.diffOri = this.oriImgHeight
      } else if (this.oriImgHeight > this.oriImgWidth) {
        this.diffX = 0
        this.diffY = (this.oriImgHeight - this.oriImgWidth) / 2
        this.diffOri = this.oriImgWidth
      } else if (this.oriImgHeight == this.oriImgWidth) {
        this.diffX = 0
        this.diffY = 0
        this.diffOri = this.oriImgWidth
      }
      // Draw img into canvas
      ctx.drawImage(
        img,
        this.diffX,
        this.diffY,
        this.diffOri,
        this.diffOri,
        0,
        0,
        width,
        height
      )
      console.log(canvas)
      var dataURL = canvas.toDataURL('image/jpeg')

      // if (exifOrientation == 0 || exifOrientation == undefined) {
      //   dataURL = img.src.canvas.toDataURL('image/jpeg')
      //   console.log(dataURL)
      // }
      console.log(dataURL)
      // if (dataURL == 'data:,' || dataURL == '' || dataURL == undefined) {
      //   console.log(img.src)
      //   canvas.src = img.src
      //   dataURL = canvas.toDataURL('image/jpeg')
      // }
      var imgAltName =
        imgTNInfo.name.substr(0, imgTNInfo.name.lastIndexOf('.')) + '.jpeg'
      console.log('1.6 dataURL:', dataURL)
      const finalFile = this.base64toFile(imgAltName, dataURL)
      console.log('1.7', finalFile)
      this.urlTN = URL.createObjectURL(finalFile)
      console.log('1.8', this.urlTN)
      const id = new Date(Date.now()).getTime()
      const tnImgItem = {
        imgPath: dataURL,
        imgAlt: imgAltName,
        file: finalFile,
        id: id
      }
      this.tnImgItem = tnImgItem
      this.loadingDialog = false
    },
    base64toFile(imgName, dataURL) {
      // convert the data URL to a byte string
      const byteString = atob(dataURL.split(',')[1])

      // pull out the mime type from the data URL
      const mimeString = dataURL
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      // Convert to byte array
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const int8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
      }
      // const fileName = imgName.substring(0, imgName.length - 4);

      // Create a blob that looks like a file.
      const file = new File([arrayBuffer], imgName, { type: mimeString })
      // file['lastModifiedDate'] = (new Date()).toISOString();
      // file['name'] = imgName.substring(0, imgName.length - 4);

      // // Figure out what extension the file should have
      // switch (file.type) {
      //   case 'image/jpeg':
      //   file['name'] += '.jpg';
      //     break;
      //   case 'image/png':
      //   file['name'] += '.png';
      //     break;
      // }
      // cast to a File
      // return <File>file;
      return file
    },
    onSelectBtnType(val, i) {
      console.log(val)
      console.log(i)

      //get gm
      if (val == 'Once') {
        this.itemPropList[i].gm = 0
        this.itemPropList[i].gmName = 'Once'
      } else if (val == 'Multiple') {
        this.itemPropList[i].gm = 3
        this.itemPropList[i].gmName = 'Multiple'
      }
      console.log(this.itemPropList)
    },
    addPrice() {
      this.emptyPriceName = ''
      this.samePriceName = false
      this.addNewPrice = true
      for (let i = 0; i < this.itemPriceList.length; i++) {
        if (this.itemPriceList[i].kz.trim() == '') {
          this.addNewPrice = false
          break
        }
      }
      if (this.addNewPrice == false) {
        this.emptyPriceName = translateErrorMsg.translateMsg(
          'Price Name cannot be empty!'
        )
        window.scrollTo(0, 0)
      } else {
        this.checkSamePriceName()
        if (this.samePriceName == true) {
          this.emptyPriceName = translateErrorMsg.translateMsg(
            'Price Name cannot be duplicated!'
          )
          window.scrollTo(0, 0)
        } else {
          this.itemPriceList.push({ ky: 0, kt: 0, kz: '', lp: 0, ou: 0 })
        }
      }
    },
    setItemPropNameInfo(val, i) {
      console.log(val)
      console.log(i)
      this.itemPropList[i].ez = val
      console.log(this.itemPropList)
    },
    setItemPropInfo(val2, i) {
      console.log(val2)
      console.log(i)
      if (val2 == null) {
        val2 = 0
      }
      this.itemPropList[i].lp = val2
      console.log(this.itemPropList)
    },
    addProperty() {
      this.emptyPropName = ''
      this.samePropName = false
      this.addNewProp = true
      for (let i = 0; i < this.itemPropList.length; i++) {
        if (this.itemPropList[i].ez.trim() == '') {
          this.addNewProp = false
          break
        }
      }
      if (this.addNewProp == false) {
        this.emptyPropName = translateErrorMsg.translateMsg(
          'Property Name cannot be empty!'
        )
        window.scrollTo(0, 0)
      } else {
        this.checkSamePropName()
        if (this.samePropName == true) {
          this.emptyPropName = translateErrorMsg.translateMsg(
            'Property Name cannot be duplicated!'
          )
          window.scrollTo(0, 0)
        } else {
          this.itemPropList.push({
            oo: 0,
            kt: 0,
            ez: '',
            lp: 0,
            gm: 0,
            gmName: 'Once'
          })
        }
      }
    },
    sureDltImg() {
      this.errImg = ''
      this.errImgWithTran = ''
      this.croppaImgFile = []
      this.myCroppa.remove()
      this.imgUrl = ''
      this.clearImgDialog = false
      this.urlTN = ''
    },
    deleteItmPrc(i) {
      this.dltPrcIndex = i
      this.deleteItmPrcDialog = true
    },
    sureDltPrc() {
      this.emptyPriceName = ''
      this.errorMenuWithTran = ''
      console.log('index:', this.dltPrcIndex)
      this.itemPriceList.splice(this.dltPrcIndex, 1)
      this.deleteItmPrcDialog = false
    },
    deleteItmProp(i) {
      this.dltPropIndex = i
      this.deleteItmPropDialog = true
    },
    sureDltProp() {
      this.emptyPropName = ''
      this.errorMenuWithTran = ''
      console.log('index:', this.dltPropIndex)
      this.itemPropList.splice(this.dltPropIndex, 1)
      this.deleteItmPropDialog = false
    },
    checkSamePriceName() {
      if (this.itemPriceList.length > 1) {
        for (let i = 0; i < this.itemPriceList.length; i++) {
          for (let j = 0; j < this.itemPriceList.length; j++) {
            if (i != j) {
              if (
                this.itemPriceList[i].kz.trim() ==
                this.itemPriceList[j].kz.trim()
              ) {
                this.samePriceName = true
                break
              }
            }
          }
        }
      } else {
        this.samePriceName = false
      }
    },
    checkSamePropName() {
      if (this.itemPropList.length > 1) {
        for (let i = 0; i < this.itemPropList.length; i++) {
          for (let j = 0; j < this.itemPropList.length; j++) {
            if (i != j) {
              if (
                this.itemPropList[i].ez.trim() == this.itemPropList[j].ez.trim()
              ) {
                this.samePropName = true
                break
              }
            }
          }
        }
      } else {
        this.samePropName = false
      }
    },
    // updateFsImage() {
    //   console.log(this.sltInputImgFile)
    //   console.log(this.urlTN)
    //   this.fsImgItem = []
    //   const reader = new FileReader()

    //   reader.onload = fs => {
    //     const id = new Date(Date.now()).getTime()
    //     console.log('done id:', id)
    //     console.log('new FileItem:', this.sltInputImgFile)
    //     console.log(fs.target.result)
    //     const fsImgItem = {
    //       imgPath: fs.target.result,
    //       imgAlt: this.sltInputImgFile.name,
    //       file: this.sltInputImgFile,
    //       id: id
    //     }
    //     console.log(fsImgItem)
    //     this.fsImgItem = fsImgItem
    //     this.tnImgItem = fsImgItem

    //     console.log(fs.target.result)
    //     //change FS Size
    //     var img = new Image()
    //     img.src = this.urlTN

    //     //set FS img
    //     var canvas = document.createElement('canvas') //FS
    //     canvas.width = 600
    //     canvas.height = 600
    //     //console.log(canvas.width)
    //     const ctx = canvas.getContext('2d')

    //     this.diffWidth = 0
    //     if (this.oriImgWidth > this.oriImgHeight) {
    //       this.diffX = (this.oriImgWidth - this.oriImgHeight) / 2
    //       this.diffY = 0
    //       this.diffOri = this.oriImgHeight
    //     } else if (this.oriImgHeight > this.oriImgWidth) {
    //       this.diffX = 0
    //       this.diffY = (this.oriImgHeight - this.oriImgWidth) / 2
    //       this.diffOri = this.oriImgWidth
    //     } else if (this.oriImgHeight == this.oriImgWidth) {
    //       this.diffX = 0
    //       this.diffY = 0
    //       this.diffOri = this.oriImgWidth
    //     }
    //     ctx.drawImage(
    //       img,
    //       this.diffX,
    //       this.diffY,
    //       this.diffOri,
    //       this.diffOri,
    //       0,
    //       0,
    //       600,
    //       600
    //     )
    //     var dataURL = canvas.toDataURL('image/jpeg')

    //     console.log(dataURL)
    //     console.log(img.alt)
    //     var imgAltName =
    //       this.sltInputImgFile.name.substr(
    //         0,
    //         this.sltInputImgFile.name.lastIndexOf('.')
    //       ) + '.jpeg'
    //     console.log(imgAltName)
    //     const finalFSJpegFile = this.base64toFile(imgAltName, dataURL)
    //     console.log(finalFSJpegFile)
    //     this.fsImgItem.imgPath = dataURL
    //     this.fsImgItem.file = finalFSJpegFile

    //     this.updateTnImage()
    //     //this.uploadImg()
    //   }
    //   reader.readAsDataURL(this.sltInputImgFile)
    // },
    // updateTnImage() {
    //   this.tnImgItem = []
    //   const reader2 = new FileReader()

    //   reader2.onload = tn => {
    //     const id = new Date(Date.now()).getTime()
    //     console.log('done id:', id)
    //     console.log('new FileItem:', this.sltInputImgFile)
    //     console.log(tn.target.result)
    //     const tnImgItem = {
    //       imgPath: tn.target.result,
    //       imgAlt: this.sltInputImgFile.name,
    //       file: this.sltInputImgFile,
    //       id: id
    //     }
    //     console.log(tnImgItem)
    //     this.tnImgItem = tnImgItem

    //     var img2 = new Image()
    //     img2.src = this.urlTN
    //     var canvas = document.createElement('canvas')
    //     canvas.width = 600
    //     canvas.height = 600
    //     const ctx = canvas.getContext('2d')

    //     ctx.drawImage(
    //       img2,
    //       this.diffX,
    //       this.diffY,
    //       this.diffOri,
    //       this.diffOri,
    //       0,
    //       0,
    //       600,
    //       600
    //     )
    //     var dataURL2 = canvas.toDataURL('image/jpeg')
    //     var imgAltName =
    //       this.sltInputImgFile.name.substr(
    //         0,
    //         this.sltInputImgFile.name.lastIndexOf('.')
    //       ) + '.jpeg'
    //     console.log(imgAltName)
    //     const finalTNJpegFile = this.base64toFile(imgAltName, dataURL2)
    //     this.tnImgItem.imgPath = dataURL2
    //     this.tnImgItem.file = finalTNJpegFile

    //     console.log(this.fsImgItem)
    //     console.log(this.fsImgItem.imgPath)
    //     console.log(this.tnImgItem)
    //     console.log(this.tnImgItem.imgPath)
    //     this.urlTN = URL.createObjectURL(finalTNJpegFile)

    //     //this.uploadImg()
    //   }
    //   reader2.readAsDataURL(this.sltInputImgFile)
    // },
    uploadImg() {
      // if (this.dltAllImg != true) {
      //   this.urlTN = URL.createObjectURL(this.fsImgItem.file)
      // }
      this.versionError = false

      let mchCode = sessionStorage.getItem('backendMchCode')

      var fileList = []
      if (this.croppaImgFile != []) {
        const file = { file: this.croppaImgFile }

        fileList.push(file)
        fileList.push(file)
      }

      console.log(fileList)

      var version = sessionStorage.getItem('version')
      const url = 'Order/UpdateImage'
      const parameter = {
        av: version,
        kp: mchCode,
        kt: this.itemId,
        ih: 0, //Fixed
        bo: this.dltAllImg //Delete All
      }
      console.log(parameter)

      JS.multipart(url, parameter, fileList, 'menuImg')
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.getItemList()
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.errorList = error
        })
    },
    saveMenu() {
      this.loadingDialog = true
      this.emptyPriceName = ''
      this.emptyPropName = ''
      this.errorMenuWithTran = ''

      console.log(this.itemPriceList)
      console.log(this.itemPropList)
      this.samePriceName = false
      this.samePropName = false
      this.ListOfItemPriceToServer = []
      this.ListOfPropToServer = []
      if (
        this.mdfItemName.trim() == '' ||
        this.mdfItemName.trim() == undefined
      ) {
        this.errorMenuWithTran = translateErrorMsg.translateMsg(
          'Menu Item Name cannot be empty.'
        )
        this.loadingDialog = false
      } else if (
        this.mdfItemCatName.trim() == '' ||
        this.mdfItemCatName.trim() == undefined
      ) {
        this.errorMenuWithTran = translateErrorMsg.translateMsg(
          'Menu Item Category Name cannot be empty.'
        )
        this.loadingDialog = false
      } else {
        this.mdfItemCatName = String(this.mdfItemCatName).replace(/,/g, '/')
        //check Price
        this.emptyPriceName = ''
        this.samePriceName = false
        if (this.itemPriceList.length > 0) {
          if (this.itemPriceList.length == 1) {
            if (
              (this.itemPriceList[0].kz.trim() == '' ||
                this.itemPriceList[0].kz.trim() == null ||
                this.itemPriceList[0].kz.trim() == undefined) &&
              this.itemPriceList[0].lp >= 0
            ) {
              this.itemPriceList[0].kz = '#'
              // this.itemPriceList.splice(i, 1)
              // i = -1
            }
          } else {
            console.log(this.itemPriceList)
            for (let i = 0; i < this.itemPriceList.length; i++) {
              if (
                this.itemPriceList[i].kz.trim() == '' ||
                this.itemPriceList[i].kz.trim() == null ||
                this.itemPriceList[i].kz.trim() == undefined
              ) {
                this.emptyPriceName = translateErrorMsg.translateMsg(
                  'Price Name cannot be empty!'
                )
                this.loadingDialog = false
                window.scrollTo(0, 0)
                // this.itemPriceList.splice(i, 1)
                // i = -1
                break
              } else {
                this.emptyPriceName = ''
              }
            }
          }
          if (this.itemPriceList.length > 0) {
            this.checkSamePriceName()
            if (this.samePriceName == true) {
              this.errorMenuWithTran = translateErrorMsg.translateMsg(
                'Price Name cannot be duplicated!'
              )
              this.loadingDialog = false
            } else {
              //set server
              for (let j = 0; j < this.itemPriceList.length; j++) {
                if (
                  this.itemPriceList[j].lp == '' ||
                  this.itemPriceList[j].lp == null ||
                  this.itemPriceList[j].lp == undefined
                ) {
                  this.itemPriceList[j].lp = 0
                }
                this.ListOfItemPriceToServer.push({
                  Name: this.itemPriceList[j].kz,
                  Price: this.itemPriceList[j].lp,
                  Type: 0, //Fixed
                  PriceName: this.itemPriceList[j].kz,
                  PriceDespKtn: '', //Fixed
                  PriceDespRcp: '' //Fixed
                })
              }
            }
          } else {
            this.ListOfItemPriceToServer = []
          }
        } else {
          this.ListOfItemPriceToServer = []
        }
        console.log(this.itemPriceList)
        console.log(this.ListOfItemPriceToServer)

        if (this.itemPriceList.length == 0) {
          this.emptyPriceName = translateErrorMsg.translateMsg(
            'Please set at least one price'
          )
          this.loadingDialog = false
          window.scrollTo(0, 0)
        } else if (this.emptyPriceName == '' && this.errorMenuWithTran == '') {
          //check Prop
          if (this.itemPropList.length > 0) {
            console.log(this.itemPropList)
            for (let l = 0; l < this.itemPropList.length; l++) {
              if (
                this.itemPropList[l].ez.trim() == '' ||
                this.itemPropList[l].ez.trim() == null ||
                this.itemPropList[l].ez.trim() == undefined
              ) {
                this.emptyPropName = translateErrorMsg.translateMsg(
                  'Property Name cannot be empty!'
                )
                this.loadingDialog = false
                window.scrollTo(0, 0)
                break
                // this.itemPropList.splice(l, 1)
                // l = -1
              } else {
                this.emptyPropName = ''
              }
            }
            if (this.itemPropList.length > 0) {
              this.checkSamePropName()
              if (this.samePropName == true) {
                this.errorMenuWithTran = translateErrorMsg.translateMsg(
                  'Property Name cannot be duplicated!'
                )
                this.loadingDialog = false
              } else {
                //set server
                for (let k = 0; k < this.itemPropList.length; k++) {
                  if (
                    this.itemPropList[k].lp == '' ||
                    this.itemPropList[k].lp == null ||
                    this.itemPropList[k].lp == undefined
                  ) {
                    this.itemPropList[k].lp = 0
                  }
                  this.ListOfPropToServer.push({
                    Index: k + 1,
                    Name: this.itemPropList[k].ez,
                    Price: this.itemPropList[k].lp,
                    Type: this.itemPropList[k].gm
                  })
                }
              }
            } else {
              this.ListOfPropToServer = []
            }
          } else {
            this.ListOfPropToServer = []
          }
          console.log(this.itemPropList)
          console.log(this.ListOfPropToServer)

          if (this.emptyPropName == '' && this.errorMenuWithTran == '') {
            for (let k = 0; k < this.itemPriceList.length; k++) {
              if (this.itemPriceList[k].lp == 0) {
                this.loadingDialog = false
                this.foundZeroPriceItemDialog = true
                break
              }
              this.foundZeroPriceItemDialog = false
            }

            if (this.foundZeroPriceItemDialog == false) {
              this.saveAddEditItem()
            }
          }
        }
      }
    },
    saveAddEditItem() {
      this.loadingDialog = true
      this.foundZeroPriceItemDialog = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))

      if (this.newOrEdit == 'new') {
        this.itemId = 0
      }

      if (this.samePriceName != true && this.samePropName != true) {
        this.versionError = false
        var parameter
        var version = sessionStorage.getItem('version')
        this.mdfItemDesp = this.$refs.editorText.invoke('getHtml')
        //alert(this.mdfItemDesp)
        //console.log(this.mdfItemDesp.length)
        if (this.newOrEdit == 'new') {
          var sendRefId = new Date().getTime()
          parameter = {
            av: version,
            kp: mchCode,
            rd: userInfo.KtnID,
            mc: '', //Fixed
            kt: this.itemId,
            ku: this.mdfItemName,
            kv: this.mdfItemDesp,
            mb: 1, //Fixed
            mr: this.mdfItemCatName,
            md: 0, //Fixed
            lu: 0, //Fixed
            lv: 0, //Fixed
            ih: 0, //Fixed
            lc: this.cActive,
            sd: this.cSellingFast,
            oc: this.cSoldOut,
            of: true, //Fixed
            ow: '', //Fixed
            od: 0, //Fixed
            ey: sendRefId,
            ListOfItemPrice: this.ListOfItemPriceToServer,
            ListOfProp: this.ListOfPropToServer,
            ListOfTmSsn: [] //Fixed
          }
        } else {
          parameter = {
            av: version,
            kp: mchCode,
            rd: userInfo.KtnID,
            mc: '', //Fixed
            kt: this.itemId,
            ku: this.mdfItemName,
            kv: this.mdfItemDesp,
            mb: 1, //Fixed
            mr: this.mdfItemCatName,
            md: 0, //Fixed
            lu: 0, //Fixed
            lv: 0, //Fixed
            ih: 0, //Fixed
            lc: this.cActive,
            sd: this.cSellingFast,
            oc: this.cSoldOut,
            of: true, //Fixed
            ow: '', //Fixed
            od: 0, //Fixed
            ListOfItemPrice: this.ListOfItemPriceToServer,
            ListOfProp: this.ListOfPropToServer,
            ListOfTmSsn: [] //Fixed
          }
        }
        const url = 'Order/AddEditItem'

        console.log(parameter)
        JS.request(url, parameter)
          .then(response => {
            console.log(response.data)
            if (
              response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              response.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              this.errorMenuWithTran = ''
              if (response.data.kt) {
                this.loadingDialog = false
                this.itemId = response.data.kt
                console.log(this.urlTN)
                console.log(this.sltInputImgFile)
                if (
                  this.imgUrl != '' &&
                  this.imgUrl != undefined &&
                  this.imgUrl != null
                ) {
                  this.dltAllImg = false
                  if (this.itemPrevImg != this.imgUrl) {
                    //this.updateFsImage()
                    // console.log(
                    //   '55555555555555555555555555555555555555555555555555'
                    // )
                    // console.log(this.tnImgItem)
                    // console.log(this.fsImgItem)
                    this.uploadImg()
                  }

                  // if (
                  //   this.sltInputImgFile != '' &&
                  //   this.sltInputImgFile != undefined
                  // ) {
                  //   this.dltAllImg = false
                  //   if (this.itemInfoUrlTN != this.urlTN) {
                  //     //this.updateFsImage()
                  //     this.uploadImg()
                  //   }
                  // } else {
                  this.getItemList()
                  // }
                } else {
                  this.dltAllImg = true
                  this.tnImgItem = []
                  this.fsImgItem = []
                  this.croppaImgFile = []
                  this.uploadImg()
                }

                this.emptyPriceName = ''
                this.emptyPropName = ''
                this.errorMenu = ''
                this.errImg = ''
                this.errImgWithTran = ''
                this.addEditItemDialog = false
                window.scrollTo(0, 0)
                this.getItemList()
              } else {
                this.loadingDialog = false
                this.errorMenu = response.data
              }
            }
          })
          .catch(error => {
            //console.log(error)
            this.errorMenu = error
            this.loadingDialog = false
            this.versionError = false
          })
      } else {
        this.loadingDialog = false
      }
    },
    cancelAddEditItemDialog() {
      this.emptyPriceName = ''
      this.emptyPropName = ''
      this.errorMenu = ''
      this.errorMenuWithTran = ''
      this.errImg = ''
      this.errImgWithTran = ''
      this.tnImgItem = []
      this.fsImgItem = []
      this.croppaImgFile = []
      this.addEditItemDialog = false
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
.vSlt .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.vSlt .v-messages {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  font-size: 0px;
  min-height: 0px;
  min-width: 0px;
  position: relative;
}
.te-popup-add-image .te-tab button {
  display: none;
}
.te-popup-add-image .te-url-type {
  display: inline !important;
}
.te-file-type {
  display: none !important;
}
.tui-editor-popup .tui-popup-body input[type='file'] {
  display: none;
}

.cboxActive {
  margin-top: 0px;
}
.imgBorder {
  width: 95%;
  height: auto;
  max-width: 155px;
}
.v-label {
  font-size: 12px !important;
}
.backEndMenuTxt {
  margin-top: 5px;
  margin-bottom: 5px;
}
.menuItemBtmBtn {
  width: 42%;
  height: auto;
  padding: 3px;
  font-size: 12px;
  margin: 5px;
}
.menuItemListLayout {
  padding: 2.5px;
  width: 16.66%;
  max-width: 16.66%;
}
.priceInputWidth {
  min-width: 100%;
}
@media (max-width: 1903px) {
  .menuItemListLayout {
    padding: 2.5px;
    width: 25%;
    max-width: 25%;
  }
}
@media (max-width: 1263px) {
  .menuItemListLayout {
    padding: 2.5px;
    width: 33.3%;
    max-width: 33.3%;
  }
}
@media (max-width: 959px) {
  .menuItemListLayout {
    padding: 2.5px;
    width: 50%;
    max-width: 50%;
  }
}
@media (max-width: 770px) {
  .priceInputWidth {
    width: 100%;
    max-width: 85px;
    /* color: whitesmoke; */
  }
}
@media (max-width: 650px) {
  .priceInputWidth {
    width: 100%;
    max-width: 85px;
    /* color: whitesmoke; */
  }
}
@media (max-width: 545px) {
  .menuItemBtmBtn {
    width: 41%;
    height: auto;
    padding: 2px;
    font-size: 12px;
    margin: 2px;
  }
}
@media (max-width: 535px) {
  .menuItemListLayout {
    padding: 2.5px;
    width: 100%;
    max-width: 100%;
  }
}
/* @media (max-width: 369px) {
  .cboxActive {
    margin-top: 8px;
  }
} */
</style>
